import React from 'react';
import { bool, shape, string } from 'prop-types';

const WorkType = ({
  className = 'icon',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="1em" height="1em" viewBox="0 0 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_11133_60571)">
      <path d="M13.575 3.75L11.2275 6.1275L10.425 5.3175L9.375 6.375L11.2275 8.25L14.625 4.8075L13.575 3.75Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M12 11.25C14.8995 11.25 17.25 8.8995 17.25 6C17.25 3.10051 14.8995 0.75 12 0.75C9.1005 0.75 6.75 3.10051 6.75 6C6.75 8.8995 9.1005 11.25 12 11.25ZM12 9.75C14.0711 9.75 15.75 8.07107 15.75 6C15.75 3.92893 14.0711 2.25 12 2.25C9.92893 2.25 8.25 3.92893 8.25 6C8.25 8.07107 9.92893 9.75 12 9.75Z" fill="currentColor" />
      <path d="M1.5 10.5007C1.5 8.61073 2.3775 6.92323 3.75 5.82823V7.12573H5.25V3.37573H0.75V4.87573H2.55C0.99 6.24823 0 8.25823 0 10.5007C0 14.3932 2.9625 17.5882 6.75 17.9632V16.4482C3.795 16.0807 1.5 13.5532 1.5 10.5007Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M6.39552 9.04072C5.56896 8.47212 4.59074 8.29902 3.79472 8.25147C3.58301 8.23883 3.37584 8.31641 3.22452 8.465C3.07319 8.6136 2.99186 8.81932 3.00065 9.03122C3.04998 10.2207 3.26327 11.7496 4.14312 12.8131L4.1465 12.8172C4.86706 13.6756 5.85518 14.0304 6.75 14.1732V15.7501H8.25V12.6833C8.92833 12.598 9.64252 12.4393 10.3286 12.1536C8.63262 11.6941 7.21728 10.5521 6.39552 9.04072ZM6.67444 12.6311C6.56715 11.8342 6.34862 11.1251 5.95286 10.6455C5.60967 10.2377 5.1281 9.99897 4.57556 9.86916C4.68285 10.666 4.90138 11.3752 5.29715 11.8548C5.64034 12.2626 6.1219 12.5013 6.67444 12.6311Z" fill="currentColor" />
      <path d="M13.238 12.2549C12.8811 13.4163 12.179 14.427 11.25 15.1732V13.8757H9.75V17.6257H14.25V16.1257H12.45C13.7322 14.9977 14.6293 13.439 14.9082 11.6745C14.3888 11.9413 13.828 12.1388 13.238 12.2549Z" fill="currentColor" />
    </g>
    <defs>
      <clipPath id="clip0_11133_60571">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

WorkType.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default WorkType;
